module.exports = __webpack_public_path__ + "assets/img/game-images-loader.cec315d4.svg";